import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UsersQueryVariables = Types.Exact<{
  filters: Types.UsersFilters;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  groupId: Types.Scalars['String']['input'];
  groupIdPresent: Types.Scalars['Boolean']['input'];
  isgroupIdsPresent: Types.Scalars['Boolean']['input'];
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  orgRoleId: Types.Scalars['String']['input'];
  isOrgRoleIdPresent: Types.Scalars['Boolean']['input'];
}>;


export type UsersQuery = { users: { totalCount: number, edges?: Array<{ node: { status: Types.UserStatusEnum, isMgsaEnabled?: boolean | null, canBeNominated: boolean, isPresentInGroup?: boolean, isInGroups?: boolean, isInOrgRole?: boolean, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { name: string, id: string } | null, responsibilities?: Array<{ id: string }> | null } }> | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null } };


export const UsersDocument = /*#__PURE__*/ gql`
    query users($filters: UsersFilters!, $sort: [SortType!], $first: Float, $after: String, $userId: String, $groupId: String!, $groupIdPresent: Boolean!, $isgroupIdsPresent: Boolean!, $groupIds: [String!]!, $orgRoleId: String!, $isOrgRoleIdPresent: Boolean!) {
  users(filters: $filters, sort: $sort, first: $first, after: $after) {
    edges {
      node {
        ...User
        status
        orgRole {
          name
        }
        isMgsaEnabled
        canBeNominated(userId: $userId)
        responsibilities {
          id
        }
        isPresentInGroup(groupId: $groupId) @include(if: $groupIdPresent)
        isInGroups(groupIds: $groupIds) @include(if: $isgroupIdsPresent)
        isInOrgRole(orgRoleId: $orgRoleId) @include(if: $isOrgRoleIdPresent)
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${UserFragmentDoc}`;

export function useUsersQuery(options: Omit<Urql.UseQueryArgs<UsersQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersQuery, UsersQueryVariables>({ query: UsersDocument, ...options });
};